import React from "../../__snowpack__/pkg/react.js";
import styled from "../../__snowpack__/pkg/styled-components.js";
import syncImg from "../assets/sync.png";
export const SyncButton = (props) => {
  const syncClick = (e) => {
    debugger;
    e.stopPropagation();
    if (props.getSyncData) {
      props.getSyncData();
    }
  };
  return /* @__PURE__ */ React.createElement(Wrapper, {
    ...props,
    onClick: syncClick
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sync-button"
  }, /* @__PURE__ */ React.createElement("img", {
    className: props.isLoading ? "logistics-choose-sync-rotating" : "",
    src: syncImg
  }), props.text || "sync"));
};
const Wrapper = styled.span`
  color: #6020ff;
  font-size: 12px;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
  .logistics-choose-sync-rotating {
    animation: turn 1s linear infinite;
  }
  .sync-button {
    display: flex;
    align-items: center;
    font-weight: 400;
  }
  @keyframes turn {
    0% {
      -webkit-transform: rotate(0deg);
    }
    25% {
      -webkit-transform: rotate(90deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
    }
    75% {
      -webkit-transform: rotate(270deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
`;
